export default __webpack_public_path__ + "static/media/download-ios.c70a990e.png";